const ACTIVITY_LIST_PREFIX = "activity-list";

export const activityListTestIds = {
  toolbarAddButton: () => ({
    id: `${ACTIVITY_LIST_PREFIX}-toolbar-add-button`,
    testId: `${ACTIVITY_LIST_PREFIX}-toolbar-add-button`,
  }),
};
